
export const baseUrl = "https://api.pelakeman.com/api"
export const baseUrlWithoutApi = "https://api.pelakeman.com"

 /*
export const baseUrl = "https://localhost:7292/api"
export const baseUrlWithoutApi = "https://localhost:7292"
*/
